import FMCalendarComponent from './Calender';


const FMCalendar = ({
  conversation,
  options,
  message,
  rows,
  messageType,
  parentTabId,
  inContainer,
  parentDocId,
}) => {


  return (
    <FMCalendarComponent
      options={options}
      message={message || rows}
      conversation={conversation}
      messageType={messageType}
      parentTabId={parentTabId}
      parentDocId={parentDocId}
      inContainer={inContainer}
    />
  );
};

export default FMCalendar;
